import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Demo } from './pages/Demo';
import { Docs } from './pages/Docs';
import { Header } from './components/Header';
import { SEO } from './components/SEO';

function App() {
  return (
    <>
      <SEO 
        title="MemPalace"
        description="基于 Cloudflare 构建的简单记忆管理工具，帮你更好地记住重要的事情。"
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/docs" element={<Docs />} />
          </Routes>
        </main>
      </div>
    </>
  );
}

export default App;
